import { render, staticRenderFns } from "./ArtworkSidebar.vue?vue&type=template&id=9f5760d4&"
import script from "./ArtworkSidebar.vue?vue&type=script&lang=js&"
export * from "./ArtworkSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkSidebar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports